import React from 'react'
import { FormattedMessage } from 'react-intl'

import { TREATMENT_OPTIONS } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/treatmentOptions'
import { TREATMENT_RECOMMENDATION_TIER } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/treatmentRecommendationsConstants'
import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import { openUrl } from '../utils/expo-linking'

export const wellspan: GetCustomerCopyFunc = () => {
  const wellSpanEAPProvidersUrl = 'https://sites.google.com/lyrahealth.com/wellspanhealth/eapproviders'
  const wellSpanEAPProvidersConfiguration = {
    analyticsName: 'WellSpan EAP Providers',
    title: (
      <FormattedMessage
        defaultMessage='WellSpan EAP Providers'
        description='Title for WellSpan EAP Providers when shown as a treatment recommendation'
      />
    ),
    description: (
      <FormattedMessage
        defaultMessage='Access confidential support for personal, family, workplace, or emotional well-being through the WellSpan Employee Assistance Program (EAP).'
        description='Description for WellSpan EAP Providers'
      />
    ),
    modalDescription: (
      <FormattedMessage
        defaultMessage='The WellSpan Employee Assistance Program (EAP) provides confidential support for personal, family, workplace, and emotional well-being concerns. Eligible team members and family members have access to 6 no-cost coaching or therapy sessions per person, per year.'
        description='Modal description for WellSpan EAP Providers'
      />
    ),
    buttonText: (
      <FormattedMessage
        defaultMessage='Learn more'
        description='Button text to learn more about WellSpan EAP Providers'
      />
    ),
    url: wellSpanEAPProvidersUrl,
    isUrlExternal: true,
  }

  return {
    customForkedTriageOptions: [
      { label: 'WellSpan EAP Providers', onPress: () => openUrl(wellSpanEAPProvidersUrl), minAge: 13 },
    ],
    treatmentOptions: [
      {
        option: TREATMENT_OPTIONS.ONSITE_THERAPY,
        config: { customCopy: wellSpanEAPProvidersConfiguration, actingSearcherMinAge: 13 },
        optionRanking: {
          [TREATMENT_RECOMMENDATION_TIER.TIER_2]: 2,
          [TREATMENT_RECOMMENDATION_TIER.TIER_3]: 1,
        },
      },
    ],
  }
}
